export const cartProps = {
  basename: "/plataforma/carrinho",
};
